
    import {defineComponent, computed, ComputedRef, watch, reactive, onMounted} from 'vue'
    import {useStore} from '@/store'
    import {useRouter, useRoute} from "vue-router";
    import  reportMsgUt from "@/util/reportMsg";
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.css';

    interface ImgItem {
        photoPath: string;
        photoIdStr: string;
    }

    interface State {
        imgList: object[];
        slideIndex: number;
        bannerSwiper: object;
        baseLength: number;
        defectLength: number;
        showLen: number;
        isBase: boolean;
        modelName: string;
        reportMsg: object;
        templateCode: string;
        isXNY: boolean;
    }

    export default defineComponent({
        name: 'swiperBanner',
        setup() {
            let state: State = reactive({
                imgList: [],
                slideIndex: 0,
                bannerSwiper: {},
                baseLength: 0,
                defectLength: 0,
                showLen: 0,
                isBase: true,
                modelName: '',
                reportMsg: {},
                templateCode: '',
                isXNY: true
            })
            state.reportMsg = reportMsgUt;
            const store = useStore()
            // 获取路由器实例
            const router = useRouter()
            const {query} = useRoute();
            const {templateCode} = query;
            state.templateCode = String(templateCode) || '';
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {photoList, defectPhotoList, modelName,energyType} = data;
                state.imgList = photoList.concat(defectPhotoList);
                state.baseLength = photoList.length;
                state.defectLength = defectPhotoList.length;
                state.showLen = state.baseLength;
                state.modelName = modelName;
                state.isXNY = energyType === 2 ? true : false;
                // console.log('baseLen:', state.baseLength, 'markLen: ', state.defectLength, 'imgLen:', state.imgList.length);
            })
            onMounted(() => {
                // 初始化banner
                state.bannerSwiper = new Swiper('.swiper-container', {
                    initialSlide: 0,
                    direction: 'horizontal',
                    loop: true,
                    virtualTranslate: false,
                    preloadImages: false,
                    observer: true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true,//修改swiper的父元素时，自动初始化swiper
                    on: {
                        slideChange: function () {
                            // console.log('slideChange, activeIndex: ', this.activeIndex);
                            if (this.activeIndex+1 > state.baseLength) {
                                // 瑕疵
                                state.slideIndex = this.activeIndex - state.baseLength;
                                state.showLen = state.defectLength;
                                state.isBase = false;
                            } else {
                                // 基本
                                state.slideIndex = this.activeIndex;
                                state.showLen = state.baseLength;
                                state.isBase = true;
                            }
                        },
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        click: function (swiper: any) {
                            router.push({
                                path:'/tocT9PhotoList',
                                query: {
                                    photoIndex: state.slideIndex,
                                    group: state.isBase ? 'base' : 'defect' ,
                                    templateCode: state.templateCode
                                }
                            })
                        }
                    }
                })
            })
            function changeGroup(groupNum) {
                if (groupNum === 0) {
                    (state.bannerSwiper as any).slideTo(0);
                } else {
                    (state.bannerSwiper as any).slideTo(state.baseLength);
                }
            }
            function urlConversion(path) {
                let reg = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i
                path = path.replace(reg, "https://$2$3$4$5$6");
                return path
            }
            return {
                state,
                changeGroup,
                urlConversion
            }
        }
    })

